import { useTranslation } from 'react-i18next';
import { S, Icon, DataCard } from '../../regureStyles';

const ContactInfo = ({ b }) => {
  const { t } = useTranslation();
  const items = [
    { icon: 'user',  label: t('screens.brokers.fieldContact', { defaultValue: 'Primary Contact' }), value: b.contact || '—' },
    { icon: 'mail',  label: t('screens.brokers.fieldEmail',                { defaultValue: 'Email' }),           value: b.email || '—' },
    { icon: 'phone', label: t('screens.brokers.fieldPhone',                { defaultValue: 'Phone' }),           value: b.phone || '—' },
    // Address rendered from address + postalCode + city + canton so
    // an imported broker (Argos load populates all four) surfaces the
    // full mailing address rather than just city/canton. Fields join
    // conditionally so brokers with sparse addresses still render.
    {
      icon: 'map-pin', label: t('screens.brokers.contactInfoAddress', { defaultValue: 'Address' }),
      value: [b.address, [b.postalCode, b.city].filter(Boolean).join(' '), b.canton].filter(Boolean).join(', ') || '—',
    },
    // Bank fields — display gap in Test Run #a. Data is populated by
    // the broker importer (iban + bankName), just wasn't rendered
    // on the detail card. Tenant-agnostic: no format assumption on
    // iban — different jurisdictions use different lengths.
    // Regulatory registration. Shown as "<authority> <number>" when the
    // authority is known, and as the number alone when it is not, matching
    // how the RC Pro proposal prints it beside the broker signature.
    {
      icon: 'shield', label: t('screens.brokers.contactInfoRegistration', { defaultValue: 'Regulatory Registration' }),
      value: b.registrationNumber
        ? [b.registrationAuthority, b.registrationNumber].filter(Boolean).join(' ')
        : '—',
    },
    { icon: 'building', label: t('screens.brokers.contactInfoBankName', { defaultValue: 'Bank Name' }), value: b.bankName || '—' },
    { icon: 'key',      label: t('screens.brokers.contactInfoIban',     { defaultValue: 'IBAN' }),      value: b.iban || '—' },
  ];
  return (
    <DataCard>
      <div style={{ fontSize: 14, fontWeight: 700, color: S.textPrimary, marginBottom: 14 }}>{t('screens.brokers.contactInfoTitle', { defaultValue: 'Contact Information' })}</div>
      {items.map(item => (
        <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              background: S.bgCard,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Icon name={item.icon} color={S.textMuted} size={16} />
          </div>
          <div>
            <div style={{ fontSize: 11, color: S.textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.8 }}>{item.label}</div>
            <div style={{ fontSize: 13, color: S.textPrimary, fontWeight: 500 }}>{item.value}</div>
          </div>
        </div>
      ))}
    </DataCard>
  );
};

export default ContactInfo;
